import { connect } from 'react-redux';
import Cards from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(Cards);
